const styles = {
  actionIcon: {
    padding: '16px',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    background: 'rgb(240, 240, 240)',

    '&:hover': {
      background: 'rgb(219, 219, 219)',
      boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
    },
  },
}

export default styles;
